(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsActivityInput', rmsActivityInputComponent);

    function rmsActivityInputComponent(lodash) {
        return {
            restrict: 'E',
            scope: {
                options: '=',
                getModel: '=?',
                reset: '=?',
                defaultModel: '=?',
                preview: '=?',
                onDiscard: '=?',
            },
            templateUrl: 'common/app/components/activities/activity-input/activity-input',
            controller: rmsActivityInputComponentCtrl,
            controllerAs: 'vm',
            bindToController: true,
            link: function(scope, elem, attr) {
                const vm = scope.vm;
                vm.hideAddAttachment = lodash.has(attr, 'hideAddAttachment');
            }
        };
    }

    var regexSignature = /(<div\sclass=['"]signature-wrapper['"]>[\S\s]*<\/div>|<p>&nbsp;<\/p>|<p><\/p>)/g;
    function rmsActivityInputComponentCtrl($scope, lodash, ActivityInputService) {
        var vm = this;
        this.$onInit = function() {
            const defaultModel = lodash.get(vm, 'defaultModel', {});
            vm.model = angular.copy(defaultModel);

            vm.getModel = getModel;
            vm.reset = reset;
            vm.handleOnChange = handleOnChange;
        }

        function getModel() {
            return vm.model;
        }

        function reset() {
            // vm.model = {};
            // vm.model = vm.defaultModel;
            // angular.merge(vm.model, angular.copy(defaultModel));
            var elements = vm.options.options.elements;
            lodash.forIn(vm.model, function(value, key) {
               var element = lodash.find(elements, {name: key});
               if (element) {
                   vm.model[key] = ActivityInputService.getTypeDefaultValue(element);
               }
            });
        }


        $scope.$watch('vm.options.options.value', function() {
           console.log('type changed');
            if (vm.options.options.value !== 'email') {
                const fieldName = lodash.get(vm.options, 'inputOptions.signatureSettings.fieldName', false);
                if (fieldName !== false && fieldName !== null) {
                    if (lodash.has(vm.model, fieldName)) {
                        vm.model[fieldName] = vm.model[fieldName].replace(regexSignature,'');
                    // } else {
                        // lodash.set(vm.model, fieldName, re)
                    }

                }
            }
        });

        function handleOnChange(name, value) {
            console.log('handleOnChange', name, value, vm.options);
            const instructions = lodash.get(vm.options, 'inputOptions.onChangeInstructions', null);
            if (!!instructions) {
                const instruction = lodash.find(instructions, {name: name});
                if (!!instruction) {
                    execOnChangeInstructions(instruction.type, value);
                }
            }
        }

        function execOnChangeInstructions(type, data) {
            switch (type) {
                case 'setSignature': {
                    setSignature(data);
                    break;
                }
                default: {
                    break;
                }
            }
        }

        function setSignature(data) {
            // get the txt description field
            const fieldName = lodash.get(vm.options, 'inputOptions.signatureSettings.fieldName', false);
            if (!!fieldName) {
                let newData = '';
                let previousData = lodash.get(vm.model, fieldName, '');
                if (!previousData) {
                    previousData = '';
                }
                previousData = previousData.replace(regexSignature,'');

                // get signature
                const signatureId = lodash.get(data, 'signature.default', null);
                const signatureLists = lodash.get(data, 'signature.list', []);
                const signature = lodash.find(signatureLists, {id: signatureId});
                if (!!signature) {
                    const signatureHtml = '<p></p><div class="signature-wrapper">' + signature.signature + '</div>';
                    newData = previousData + signatureHtml;
                } else {
                    newData = previousData;
                }

                lodash.set(vm.model, fieldName, newData);

                // $rootScope.$apply();
            }
        }


        // $scope.$watch(function() {
        //     return vm.model.sel_email_from;
        // }, function() {
        //     console.log(vm);
        //
        // })
    }
})();